import React, { useEffect } from "react";
import service1 from "../../assets/img/service_4.png";
import phone_icon from "../../assets/img/phone.png";
import { ReactTyped } from "react-typed";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../App.css";
import { Link } from "react-router-dom";

const CarpetCleaning = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="service_detail_page">
      <h2 className="service_detail_title" data-aos="fade-down">
        Carpet Cleaning and Floor Care
      </h2>

      <img
        src={service1}
        alt="Carpet Cleaning and Floor Care"
        className="service_detail_image"
        data-aos="zoom-in"
      />

      <p className="service_detail_cta" data-aos="fade-up">
        Restoration with method. Protection with intent.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Carpet and floor care in Auckland delivered using recognised
        professional methods and commercial grade equipment. Suitable for
        residential and commercial environments requiring proper surface care,
        not cosmetic treatment.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Each booking follows a defined assessment and outcome focused approach.
        Whether standalone or part of a maintenance programme, the goal is
        longer surface life, improved appearance and clear documentation of work
        completed.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Environmentally conscious solutions are used where appropriate and
        compatible with the surface.
      </p>

      <h4 className="service_subheading" data-aos="fade-up">
        Who We Support
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Residential properties</li>
        <li>Commercial facilities</li>
        <li>Schools, gyms and offices</li>
        <li>Property managers and builders</li>
      </ul>

      <h4 className="service_subheading" data-aos="fade-up">
        Why Luxe Sparkle
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Professional methods clearly communicated</li>
        <li>Surface specific approach rather than generic treatment</li>
        <li>Suitable for maintenance planning or one off restoration</li>
        <li>Structured reporting for commercial clients</li>
      </ul>

      <p className="service_detail_cta" data-aos="fade-up">
        Surfaces restored with care. Not simply refreshed for appearance.
      </p>

      <div className="service_btn_wrapper" data-aos="fade-up">
        <Link to="/booking" className="service_btn">
          Get a Free Quote
        </Link>
      </div>

      <div className="service_contact_section">
        <div className="about_sub2">
          <div className="about_contact">
            <p className="contact-lead">
              Looking for the cleaning service in Auckland?
              <br />
              Contact us now!
            </p>
            <div className="call_btn" data-aos="fade-down">
              <div className="call_inner">
                <div className="call_icon">
                  <img src={phone_icon} alt="Phone" />
                </div>
                <a className="call-button" href="tel:092430470">
                  09 243 0470
                </a>
              </div>
            </div>
          </div>

          <div className="about_faq">
            <ReactTyped
              strings={["Need help?", "Have questions?", "Check our FAQs!"]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
            <br />
            <Link className="faq-button" to="/FAQs">
              FAQs
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarpetCleaning;
